import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Modal,
} from "rsuite";
import { SongServices } from "../../../core/services/SongServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Songs.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { displayField, processSecond } from "../../../utils/helpers";

const ViewSongModal = (props: any) => {
  const { t } = useTranslation();
  const songViewId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [songInfo, setSongInfo] = useState<any>({});
  async function getViewSongDetail(id: number) {
    try {
      setLoader(true);
      const res = await SongServices.viewSong(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setSongInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewSongDetail(songViewId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="songs">
            <Container className="container">
              {songInfo && Object.keys(songInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <div style={{ width: "200px" }}>
                      <div>
                        <img
                          style={{
                            borderRadius: "100%",
                            width: 100,
                            height: 100,
                            border: "1px solid black",
                          }}
                          src={
                            songInfo && songInfo?.media_image_url
                              ? songInfo.media_image_url
                              : UtilityServices.getLoggedInUser(
                                  "song_default_image"
                                )
                          }
                          alt=""
                        />{" "}
                        {processSecond(songInfo?.media_duration)}
                      </div>
                    </div>
                    <Form.Group controlId="title">
                      <Form.ControlLabel>
                        {t("SONG")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="language_title">
                      <Form.ControlLabel>{t("LANGUAGE")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.language_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="singer1_name">
                      <Form.ControlLabel>{t("SINGER1")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.singer1_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="singer2_name">
                      <Form.ControlLabel>{t("SINGER2")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.singer2_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="singer3_name">
                      <Form.ControlLabel>{t("SINGER3")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.singer3_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="singer4_name">
                      <Form.ControlLabel>{t("SINGER4")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.singer4_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="singer_combination">
                      <Form.ControlLabel>
                        {t("PLAY")} {t("TYPE")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.singer_combination}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="composer">
                      <Form.ControlLabel>{t("COMPOSER")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.composer}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="lyricist">
                      <Form.ControlLabel>{t("LYRICIST")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.lyricist}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="album_name">
                      <Form.ControlLabel>
                        {t("ALBUM")} | {t("MOVIE")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.album_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="release_year">
                      <Form.ControlLabel>
                        {t("RELEASE")} {t("YEAR")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.release_year}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="actor1_name">
                      <Form.ControlLabel>{t("ACTOR1")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.actor1_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="actor2_name">
                      <Form.ControlLabel>{t("ACTOR2")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.actor2_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="actor3_name">
                      <Form.ControlLabel>{t("ACTOR3")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.actor3_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="license_title">
                      <Form.ControlLabel>{t("LICENSE")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.license_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="label">
                      <Form.ControlLabel>{t("LABEL")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.label}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="genre_title">
                      <Form.ControlLabel>{t("GENRE")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.genre_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="sub_genre_title">
                      <Form.ControlLabel>{t("SUB_GENRE")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.sub_genre_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="song_type">
                      <Form.ControlLabel>
                        {t("SONG")} {t("TYPE")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.song_type}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="moods">
                      <Form.ControlLabel>{t("MOOD")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.moods}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="tempo">
                      <Form.ControlLabel>{t("TEMPO")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.tempo}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="era">
                      <Form.ControlLabel>{t("ERA")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.era}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="season_title">
                      <Form.ControlLabel>
                        {t("FESTIVE")} {t("SEASON")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.season_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="rating_chart_title">
                      <Form.ControlLabel>
                        {t("RATING")} {t("CHART")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.rating_chart_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="media_type">
                      <Form.ControlLabel>
                        {t("MEDIA")} {t("TYPE")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.media_type}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="sourced_from">
                      <Form.ControlLabel>
                        {t("SOURCED")} {t("FROM")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${songInfo?.sourced_from}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewSongModal;
